import { render } from "./TrainingCard.vue?vue&type=template&id=627c0f4d"
import script from "./TrainingCard.vue?vue&type=script&lang=js"
export * from "./TrainingCard.vue?vue&type=script&lang=js"
script.render = render

export default script